<template lang="html">
  <div class="order_col_item clearfix">
    <div class="form_check">
      <label :for="'product['+product.id+']'">
        <input
            type="checkbox"
            class="table-product-checkbox"
            :name="'product['+product.id+']'"
            :id="'product['+product.id+']'"
            :checked="this.selected"
            @click="select(product.id)"
        />
        <span class="checkmark"></span>
        <div class="cart_img"><img :src="product.image"/></div>
        <div class="cart_title_wrap">
          <div class="unit_s mobile_only">{{ product.quantity }} {{unit}}</div>
          <div class="cart_title" v-html="product.name"></div>
          <div class="pr_title_note">{{ product.note }}</div>
        </div>
        <div class="cart_col_count no_mobile">
          <div
              class="addto_cart"
              :class="{ show_it: toggleAmount }"
              @mouseover="toggle_am"
              @mouseleave="toggleOut"
          >
            <div class="addto_cart_in clearfix">
              <div class="right minus" v-if="!isGiftProduct">
                <a href="javascript:void(0);" @click="decrementProduct(product);">
                  <minus_svg></minus_svg>
                </a>
              </div>
              <div class="right c_num" @click="toggle_am">
                <input
                    class="addto_cart_num"
                    type="number"
                    v-model="qty"
                    :readonly="isGiftProduct"
                />
                <div class="c_units">{{ selectedText }}</div>
              </div>
              <div class="right plus" v-if="!isGiftProduct">
                <a href="javascript:void(0);" @click="incrementProduct(product);">
                  <plus_svg></plus_svg>
                </a>
              </div>
            </div>
            <Producttype :product="product"></Producttype>
          </div>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import Vuex, {mapActions} from "vuex";
import Producttype from "../../Product/ProductType";
import plus_svg from "@/assets/img/plus.svg";
import minus_svg from "@/assets/img/minus.svg";

export default {
  props: [
      'product',
      'selected'
  ],
  data() {
    return {
      toggleAmount: false,
      qty: 0
    };
  },
  mounted() {
    this.qty = this.product.quantity;
  },
  methods: {
    ...Vuex.mapActions([
      "removeProduct",
      "calculatePrice"
    ]),
    incrementProduct(product) {
      if (product.selected === "kg") {
        this.qty = parseFloat(this.qty) + 0.5;
      } else {
        this.qty++;
      }
    },
    decrementProduct(product) {
      if (product.selected === "kg") {
        this.qty = parseFloat(this.qty) - 0.5;
      } else {
        this.qty--;
      }
      if (this.qty <= 0) this.qty = 0;
    },
    select(product_id) {
      console.log('select', product_id);
      this.$emit('select', product_id);
    },
    toggleOut() {
      setTimeout(() => {
        this.toggleAmount = false;
      }, 400);
    },
    toggle_am() {
      this.toggleAmount = true;
    },
    triggerToggleAmount() {
      setTimeout(() => {
        this.toggleAmount = true;
      }, 500);
    },
  },
  computed: {
    ...Vuex.mapGetters({
      selectedTextG: "selectedText",
      // unitPriceTextG: "unitPriceText",
      // getSaleG: "getSale",
      // getWeightText: "getWeightText"
      // //   dateformated: "cartDateFormated"
    }),
    selectedText() {
      return this.selectedTextG(this.product);
    },
    isGiftProduct() {
      if (this.sale && typeof this.product.giftedProduct == 'number' && this.product.giftedProduct > 0) {
        return true;
      }
      return false;
    },
    unit() {
      if (this.product.selected == "unit") {
        return "יח׳";
      }
      if (this.product.selected == "kg") {
        return "ק״ג";
      }
      return "יח׳";
    }
  },
  components: {
    Producttype,
    plus_svg,
    minus_svg,
  }
};
</script>

<style lang="sass" scoped>
.form_check
  font-size: inherit

  .checkmark
    background-color: #fff
    top: 17px

  label
    font-weight: normal
    margin: 0
    display: flex
    align-items: center
    column-gap: 10px

    .cart_img
      width: auto
      flex: 1 0 20%
      margin: 0

    .cart_title_wrap
      width: auto
      flex: 1 0 39%
      margin: 0

    .cart_col_count
      width: auto
      flex: 1 0 33%
      margin: 0 0 0 10px

@media (max-width: 800px)
  .order_col_item
    align-items: start
    height: auto !important
    margin: 0 !important

    .form_check
      margin: 0 !important

      label
        span.checkmark
          top: 40px

        .cart_img
          flex: 1 0 10%
</style>
